import {
  createContext,
  PropsWithChildren,
  useCallback,
  useContext,
  useMemo,
  useState,
} from 'react';

type RowVisibilityContextState = {
  hiddenRowIds: string[];
  hideRows: (rowIds: string[]) => void;
  showRows: (rowIds: string[]) => void;
};
const RowVisibilityContext = createContext<RowVisibilityContextState | null>(null);

export const useRowVisibilityContext = () => {
  const context = useContext(RowVisibilityContext);

  return context;
};

export const RowVisibilityProvider = ({ children }: PropsWithChildren<{}>) => {
  const [hiddenRowIds, setHiddenRowIds] = useState<string[]>([]);

  const hideRows = useCallback((rowIds: string[]) => {
    setHiddenRowIds((prev) => Array.from(new Set([...prev, ...rowIds])));
  }, []);
  const showRows = useCallback((rowIds: string[]) => {
    setHiddenRowIds((prev) => prev.filter((id) => !rowIds.includes(id)));
  }, []);

  const value = useMemo(
    () => ({ hiddenRowIds, hideRows, showRows }),
    [hiddenRowIds, hideRows, showRows]
  );
  return <RowVisibilityContext.Provider value={value}>{children}</RowVisibilityContext.Provider>;
};
